import React from 'react';
import { dynastyTheme } from '../../services/colorService';

const Linescore = ({ linescore, gameInfo }) => {
  if (!linescore) return null;

  const innings = linescore.innings || [];
  const totals = linescore.totals || {};
  const maxInnings = Math.max(9, innings.length);
  const headerNums = Array.from({ length: maxInnings }, (_, i) => i + 1);

  const cellClass = `py-1.5 px-2 text-center text-xs ${dynastyTheme.classes.text.white}`;
  const headerClass = `py-1.5 px-2 text-center text-xs font-bold ${dynastyTheme.classes.text.neutralLight}`;
  const totalClass = `py-1.5 px-2 text-center text-xs font-bold ${dynastyTheme.classes.text.primary}`;

  return (
    <div className="overflow-x-auto">
      <table className="w-full text-xs">
        <thead>
          <tr className={`${dynastyTheme.classes.bg.darkLighter} border-b ${dynastyTheme.classes.border.neutral}`}>
            <th className={`py-1.5 px-3 text-left text-xs font-bold ${dynastyTheme.classes.text.white} min-w-[60px]`}></th>
            {headerNums.map(n => (
              <th key={n} className={headerClass} style={{ minWidth: '28px' }}>{n}</th>
            ))}
            <th className={`w-[2px] p-0 ${dynastyTheme.classes.bg.neutral}`}></th>
            <th className={totalClass} style={{ minWidth: '32px' }}>R</th>
            <th className={totalClass} style={{ minWidth: '32px' }}>H</th>
            <th className={totalClass} style={{ minWidth: '32px' }}>E</th>
          </tr>
        </thead>
        <tbody>
          {['away', 'home'].map(side => {
            const team = side === 'away' ? gameInfo?.away_team : gameInfo?.home_team;
            const t = totals[side] || {};
            return (
              <tr key={side} className={`border-b ${dynastyTheme.classes.border.neutral}`}
                  style={{ backgroundColor: dynastyTheme.tokens.colors.neutral[side === 'away' ? 900 : 800] }}>
                <td className={`py-1.5 px-3 font-bold text-xs ${dynastyTheme.classes.text.white}`}>{team}</td>
                {headerNums.map(n => {
                  const inn = innings.find(i => i.num === n);
                  const runs = inn ? inn[side] : '';
                  return <td key={n} className={cellClass}>{runs !== '' && runs !== undefined ? runs : ''}</td>;
                })}
                <td className={`w-[2px] p-0 ${dynastyTheme.classes.bg.neutral}`}></td>
                <td className={`py-1.5 px-2 text-center text-xs font-bold ${dynastyTheme.classes.text.success}`}>{t.runs ?? 0}</td>
                <td className={`py-1.5 px-2 text-center text-xs font-bold ${dynastyTheme.classes.text.white}`}>{t.hits ?? 0}</td>
                <td className={`py-1.5 px-2 text-center text-xs font-bold ${dynastyTheme.classes.text.error}`}>{t.errors ?? 0}</td>
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  );
};

export default Linescore;
